export default __webpack_public_path__ + "static/media/REFUGIO.a89fd911.gif";